import React from 'react'
import { getPresentationContentStyles, Grid, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined'

const useStyles = makeStyles<Theme, PicturesPlaceholderProps>(
  (theme) => ({
    root: {
      '&$root': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 125,
        backgroundColor: theme.palette.grey[100],
        ...getPresentationContentStyles(theme, { noMargins: ['li'] })
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      textAlign: 'center'
    }
  }),
  { name: 'PicturesPlaceholder' }
)

export interface PicturesPlaceholderProps {
  classes?: StyleClasses<typeof useStyles>
}

function PicturesPlaceholder(props: PicturesPlaceholderProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <Grid className={classes.container} container spacing={1}>
        <Grid item xs={8}>
          <PhotoLibraryOutlinedIcon />
        </Grid>
        <Grid item xs={8}>
          <Typography variant={'h2'}>Pictures</Typography>
        </Grid>
        <Grid className={classes.container} item xs={8}>
          <Typography variant={'subtitle1'}>The job's own pictures are inserted automatically.</Typography>
          <Typography variant={'subtitle1'}>
            When viewing or sending, the job's pictures will be inserted wherever this placeholder is set in the
            presentation.
          </Typography>
        </Grid>
        <Grid className={classes.container} item xs={6}></Grid>
      </Grid>
    </div>
  )
}

export default PicturesPlaceholder
